import API from 'src/api/api';
import { parseJSON } from 'src/utils/common.util';
interface IAppointmentForm {
  forms: Record<string, unknown>;
  isOnlineBookingEnabled: boolean;
}
const getOnlineBookingFormStatus = async (isLoggedIn) => {
  const appointmentForm: IAppointmentForm = {
    forms: {},
    isOnlineBookingEnabled: false
  };
  const formResponse = await API().get(
    `/account/v1/public/appointment-booking/forms?accountId=${(parseJSON('tenantInfo') as any).accountId
    }`
  );

  if (formResponse.status === 200) {
    appointmentForm.forms = formResponse.data.forms;
    const isOABFormPublished = formResponse.data.forms[0].isPublished;
    if (!isOABFormPublished && !isLoggedIn) {
      appointmentForm.isOnlineBookingEnabled = isOABFormPublished;
    } else {
      const generalSettingsResponse = await API().get(
        `/account/v1/public/appointment-booking/general-settings?accountId=${(parseJSON('tenantInfo') as any).accountId
        }`
      );
      if (generalSettingsResponse.status === 200) {
        appointmentForm.isOnlineBookingEnabled = isLoggedIn
          ? generalSettingsResponse.data.showPatientPortalExistingPatientOnlineBooking
          : generalSettingsResponse.data.showPatientPortalNewPatientOnlineBooking;
      }
    }
  }
  return appointmentForm;
};

export { getOnlineBookingFormStatus };
